import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
// import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

// import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
// import plusIcon from "./../../../../assets/icons/plus.png";
import Cancel from "../../../assets/icons/close.png";

// import Cancel from "./../../../../assets/icons/close.png";
import CancelIcon from "@mui/icons-material/Cancel";
// import galleryIcon from "./../../../../assets/icons/gallery.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jwt_decode from "jwt-decode";
import LoadingView from "../../components/LoadingView/LoadingView.js";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";

// import LoadingView from "./../../../components/LoadingView/LoadingView.js";
// import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";

function AddDeliveryManSetup(props) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [tokenData, setTokenData] = useState({});
  const [roleDatas, setRoleDatas] = useState([]);
  const [restaurantDatas, setRestaurantDatas] = useState([]);
  const [restaurantData, setRestaurantData] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validEmail, setValidEmail] = useState(true);
  const [validPhoneNumber, setValidPhoneNumber] = useState(true);
  const [validRestaurant, setValidRestaurant] = useState(true);
  const [validRole, setValidRole] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const handleClose = () => {
    setEmail("");
    setPhoneNumber("");
    setOpenConfirmationModal(false);
    props.onHandleAddItem(false);
  };

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");
    let decodedData = {};

    if (token) {
      try {
        decodedData = jwt_decode(token);
        setTokenData(decodedData);
      } catch (error) {
        console.error("Token decode error: ", error);
      }
    }

    try {
      const roleResponse = await axios.get(
        `${apiAddress}/api/RestaurantEmployeeRanking`,
      );
      const restaurantResponse = await axios.get(
        `${apiAddress}/api/EmployeeInvitationLink/getrestaurantdetailsbyuserid/${decodedData.UserId}`,
      );
      console.log("roleResponse: ", roleResponse.data);
      const currentEmployee = roleResponse.data.find(
        (x) => x.restaurantEmployeeRank === decodedData.UserRole,
      );
      const tempRole = roleResponse.data
        .filter(
          (dt) => currentEmployee.rank < dt.rank || currentEmployee.rank === 6,
        )
        .map((dt) => ({
          id: dt.id,
          title: dt.restaurantEmployeeRank,
        }));

      setRoleDatas(tempRole);
      setRestaurantDatas(restaurantResponse.data);
    } catch (error) {
      console.error("Error loading data: ", error);
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePhoneNumberChange = (event) => {
    const value = event.target.value;
    const isValid = !isNaN(value) && value.length <= 11;
    setPhoneNumber(value);
    setValidPhoneNumber(isValid);
  };

  const handleRestaurantChange = (event, newValue) => {
    setRestaurantData(newValue?.id || null);
    setValidRestaurant(!!newValue);
  };

  const handleRoleChange = (event, newValue) => {
    setRoleData(newValue?.id || null);
    setValidRole(!!newValue);
  };

  const validateForm = () => {
    let isValid = true;

    if (!email.includes("@")) {
      setValidEmail(false);
      isValid = false;
    } else {
      setValidEmail(true);
    }

    if (!phoneNumber || phoneNumber.length > 11) {
      setValidPhoneNumber(false);
      isValid = false;
    } else {
      setValidPhoneNumber(true);
    }

    // if (!restaurantData) {
    //   setValidRestaurant(false);
    //   isValid = false;
    // } else {
    //   setValidRestaurant(true);
    // }

    // if (!roleData) {
    //   setValidRole(false);
    //   isValid = false;
    // } else {
    //   setValidRole(true);
    // }

    return isValid;
  };

  const submit = async () => {
    if (!validateForm()) {
      return;
    }

    if (!tokenData?.courierId) {
      toast.error("You must be a registered Courier to send invitations.", {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return; // ← stop here – do NOT proceed to API or loading
    }

    setLoadingModal(true);

    const employeeSetupView = {
      Email: email,
      contactNumber: phoneNumber,
      // restaurantName: restaurantData,
      // role: roleData,
      CreatorId: tokenData.UserId,
      courierId: tokenData.courierId,
    };

    try {
      var res = await axios.post(
        `${apiAddress}/api/DeliveryMan/InsertDeliveryManInvitationLink`,
        employeeSetupView,
      );
      console.log("API response: ", res.data);
      handleClose();
      props.fetchInvitations(); // ← refresh the list after successful submission
      toast.success("Successfully Send", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      console.log("Error submitting data: ", error);
      toast.error(error.response?.data.message || "Error saving data", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoadingModal(false);
    }
  };

  return (
    <div>
      <React.Fragment>
        <Dialog fullWidth={true} open={props.open} maxWidth={"md"}>
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openConfirmationModal}
            onyes={handleClose}
            close={() => setOpenConfirmationModal(false)}
            id={2}
          />
          <ToastContainer />
          <LoadingView
            open={loadingModal}
            close={() => setLoadingModal(false)}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Send Invitation link</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={() => setOpenConfirmationModal(true)}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Email Address
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  label="Email Address"
                  value={email}
                  onChange={handleEmailChange}
                  fullWidth
                />
                {!validEmail && (
                  <span style={{ color: "red" }}>Email is not valid</span>
                )}
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Contact Number
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextField
                  label="Contact Number"
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                  fullWidth
                />
                {!validPhoneNumber && (
                  <span style={{ color: "red" }}>
                    Contact Number is empty or not valid
                  </span>
                )}
              </Grid>
            </Grid>
            {/* <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Select Restaurant
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  options={restaurantDatas}
                  getOptionLabel={(option) => option.title}
                  onChange={handleRestaurantChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Restaurant Name" />
                  )}
                />
                {!validRestaurant && (
                  <span style={{ color: "red" }}>Restaurant Name Required</span>
                )}
              </Grid>
            </Grid> */}
            {/* <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Role</Typography>
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  options={roleDatas}
                  getOptionLabel={(option) => option.title}
                  onChange={handleRoleChange}
                  renderInput={(params) => (
                    <TextField {...params} label="Role" />
                  )}
                />
                {!validRole && (
                  <span style={{ color: "red" }}>Role Required</span>
                )}
              </Grid>
            </Grid> */}
          </div>
          <Grid container sx={{ padding: "0.5rem" }}>
            <Grid item xs={12}>
              <div className="d-flex justify-content-end">
                <Button onClick={submit}>Send Invitation Link</Button>
              </div>
            </Grid>
          </Grid>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default AddDeliveryManSetup;
